import * as v from "valibot";

export const SOURCING_STATS_DAYS = [7, 30, 90] as const;

export const DEFAULT_SOURCING_STATS_DAYS = 30;

export const searchParams = v.object({
  days: v.optional(v.picklist(SOURCING_STATS_DAYS)),
});

export type SourcingOverviewSearch = v.InferOutput<typeof searchParams>;

export type SourcingStatsDays = (typeof SOURCING_STATS_DAYS)[number];
